import {useEffect, useRef} from 'react';
import useLongTask from 'hooks/useLongTask';

const usePortalLongTask = (portalMid: string, onClose: CallableFunction) => {
    const downloadRef = useRef<HTMLAnchorElement>(null);

    const {longTask, longTaskApiError, onFinish, progressRef, setLongTask} =
        useLongTask(
            (longTaskMid: string) =>
                `/portal/${portalMid}/download/${longTaskMid}/progress/`,
        );

    useEffect(() => {
        if (
            longTask?.uilongtask.finished &&
            !longTask?.uilongtask.errors.length &&
            !longTaskApiError
        ) {
            downloadRef.current?.click();
            onClose();
        }
    }, [longTask, longTaskApiError, onClose]);

    return {
        downloadRef,
        longTask,
        longTaskApiError,
        onFinish,
        progressRef,
        setLongTask,
    };
};

export default usePortalLongTask;
